export function objectMergeCascade<BaseType extends object, StyleType extends object>(
  cascade: (BaseType | StyleType)[],
): BaseType {
  const result: Record<string, any> = {};
  for (let i = cascade.length - 1; i >= 0; i--) {
    const obj = cascade[i];
    for (const [key, value] of Object.entries(obj)) {
      if ((!(key in result) || result[key] === undefined) && value !== undefined) {
        result[key] = value;
      }
    }
  }
  return result as BaseType;
}
